import React from "react";
import filesize from "filesize";
import { Body, Title } from "@components";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";
import { getIconByFilename } from "@utils/fileUtils";

type Props = {
  files: File[];
};

export const DocumentList: React.FC<Props> = (props) => {
  const classes = useStyles({});

  const fileList = props.files.map((file, i) => {
    const icon = getIconByFilename(file.name);

    return (
      <div key={file.name + i}>
        <div className={classes.file}>
          {React.cloneElement(icon, { fontSize: "inherit" })}
          <Title style={{ fontWeight: "bold" }}>{file.name}</Title>
        </div>

        <Body style={{ textAlign: "center" }}>({filesize(file.size)})</Body>
      </div>
    );
  });

  return <>{fileList}</>;
};

const useStyles = makeStyles((theme: ThemeType) => ({
  file: {
    alignItems: "baseline",
    display: "flex",
    justifyContent: "center",

    "& > svg": {
      marginRight: theme.spacing()
    }
  }
}));
